import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Modal from './Modal';
import i18n from '../utils/i18n';
import { resetModal } from '../actions/modalsActions';
import { bookingOperationErrorSubtypesMessages } from '../utils/constants';

import './styles/BookingFailureModal.scss';

const BookingFailureModal = ({ resetModal: reset, modalData }) => (
  <div>
    <Modal
      isOpen={ true }
      onRequestClose={ reset }
      closeButtonText={ i18n.t('modals.bookingComplete.DONE') }
      showActionButton={ false }
    >
      <div className="modal-container booking-failure-modal">
        <h1 className="modal-header booking-failure-modal-header">
          {i18n.t('modals.bookingComplete.BOOKING_FAILURE')}
          {bookingOperationErrorSubtypesMessages[modalData.error_subtype]}
        </h1>
      </div>
    </Modal>
  </div>
);

BookingFailureModal.propTypes = {
  resetModal: PropTypes.func.isRequired,
  modalData: PropTypes.shape({
    error_subtype: ''
  })
};

BookingFailureModal.defaultProps = {
  modalData: {
    error_subtype: ''
  }
};

const mapStateToProps = state => ({
  modalData: state.modals.modalData
});

export default connect(
  mapStateToProps,
  { resetModal }
)(BookingFailureModal);



// WEBPACK FOOTER //
// ./src/modals/BookingFailureModal.js